<template>
  <div class="container-box">
    <div class="container-inner">
      <h2 class="title-type-1">광고주 등록</h2>
      <v-form ref="form" v-model="valid">
        <!--advertiser name -->
        <h3 class="title-type-3">
          광고주 회사명
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>
        <div class="relative white rounded pa-6 pr-16 mb-8">
          <v-text-field
            class="input-custom-2"
            height="40px"
            v-model="advertiserName"
            placeholder="20자 이내 입력해주세요."
            solo
            required
            :rules="advertiserNameRules"
          ></v-text-field>
          <p class="form-coment-1 mt-n2">
            <v-icon>mdi-alert-circle-outline</v-icon>
            회사명은 변경이 불가합니다.
          </p>
        </div>
        <!--// advertiser name -->
        <!--//form-wrap-->
        <div class="form-wrap">
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              광고주 분류
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6 pr-16">
              <v-select
                :items="searchSel"
                label="선택"
                v-model="searchSelChoice"
                item-color="#000"
                class="input-custom-2"
                height="40px"
                solo
                required
              ></v-select>
            </div>
          </div>

          <div class="form-group mb-8">
            <h3 class="title-type-3">
              업종
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6 pr-16">
              <v-select
                :items="searchSel2"
                label="선택"
                v-model="searchSelChoice2"
                item-color="#000"
                class="input-custom-2"
                height="40px"
                solo
                required
              ></v-select>
            </div>
          </div>
        </div>
      </v-form>
      <div class="form-wrap">
        <div class="form-group mb-8">
          <h3 class="title-type-3">담당자 성명</h3>
          <div class="relative white rounded pa-6 pr-16">
            <v-text-field
              class="input-custom-2"
              type="text"
              height="40px"
              v-model="managerName"
              solo
              required
            ></v-text-field>
          </div>
        </div>

        <div class="form-group mb-8">
          <h3 class="title-type-3">대표 이메일 주소</h3>
          <div class="relative white rounded pa-6 pr-16">
            <v-text-field
              class="input-custom-2"
              type="text"
              height="40px"
              v-model="advertiserEmail"
              :rules="eamilRules"
              solo
              hide-details="auto"
            ></v-text-field>
          </div>
        </div>
      </div>
      <!--//form-wrap-->
      <div class="d-flex justify-end mt-10">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fff"
          class="button-type-1"
          @click.stop="cancel"
        >
          취소
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1 ml-4"
          :disabled="!valid || !searchSelChoice || !searchSelChoice2"
          @click.prevent="registerAdvertiser"
        >
          저장
        </v-btn>
      </div>
    </div>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import { createAdvertiser } from '@/api/advertiser';
import { sectors } from '@/api/etc';
import { constantAdvertiserType } from '@/utils/constant';
import bus from '@/utils/bus.js';

import SystemAlert from '~@/modal/SystemAlert.vue';

export default {
  components: { SystemAlert },
  data: () => ({
    valid: false,
    components: {
      SystemAlert,
    },
    showSystemAlert: false,

    advertiserName: '',
    advertiserNameRules: [
      v => !!v || '광고주명을 입력해주세요.',
      v =>
        (v && /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '한글, 영문, 숫자만 입력 가능합니다.',
      v => (v && v.length <= 20) || '최대 20자 이내로 입력해주세요.',
    ],
    searchSel: ['광고주', '대행사', '내부광고'],
    searchSelChoice: '',

    searchSel2: [],
    searchSelChoice2: '',
    sectorsMap: {},

    managerName: '',
    advertiserEmail: '',
    eamilRules: [v => /.+@.+\..+/.test(v) || '이메일 형식을 지켜주세요.'],

    logResult: '',
    resultType: '',
  }),
  methods: {
    async registerAdvertiser() {
      //bus.$emit('start:spinner');
      try {
        const advertiserData = {
          type: this.getKeyByValue(
            constantAdvertiserType,
            this.searchSelChoice,
          ),
          name: this.advertiserName,
          email: this.advertiserEmail.trim(),
          manager_name: this.managerName.trim(),
          sector: {
            id: this.sectorsMap[this.searchSelChoice2].id,
          },
        };
        const { data } = await createAdvertiser(advertiserData);

        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = '신규 계정이 발급 되었습니다.';
        }
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        this.resultType = data.result;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 회사명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다.<br>재등록 부탁드립니다.';
        }
      }
    },
    async getSector() {
      try {
        const { data } = await sectors();
        const list = data.list;
        const listMap = {};
        const names = [];
        (list || []).forEach(item => {
          listMap[item.name] = item;
          names.push(item.name);
        });
        this.sectorsMap = listMap;
        this.searchSel2 = names;
      } catch (error) {
        console.log(error.response);
      }
    },
    getKeyByValue(object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },
    openPopup() {
      this.searchAdveriser = true;
    },
    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      if (type === 'success') {
        this.$router.push({ name: 'partners' }).catch(() => {});
      }
    },
    cancel() {
      this.$router.push({ name: 'partners' }).catch(() => {});
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async hideHint(event) {
      if (event.target.value === '') {
        await this.$refs.form2.resetValidation();
      }
    },
  },
  created() {
    this.getSector();
  },
};
</script>

<style></style>
